import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ClassModel, ClassService } from '../class';
import { PlaceModel, PlaceService } from '../place';
import { AssetModel, assetStates, AssetStateModel } from '../asset';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-asset-edit',
  templateUrl: './asset-edit.component.html',
  styleUrls: ['./asset-edit.component.scss']
})
export class AssetEditComponent implements OnInit, OnDestroy {

  @Input() asset: AssetModel = new AssetModel();
  @Output() assetChanged = new EventEmitter<AssetModel>();

  date = new UntypedFormControl(this.asset.aquisitionDate);

  allAssetStates = assetStates;
  currentState: AssetStateModel = assetStates[0];

  classes: ClassModel[] = [];
  places: PlaceModel[] = [];

  subs = new Subscription();

  constructor(private classService: ClassService, private placeService: PlaceService) {

    this.subs.add(this.date.valueChanges.subscribe(
      (data) => {
        this.asset.aquisitionDate = data;
        this.assetChanged.emit(this.asset);
      },
      (error) => {},
      () => {}
    ));

    this.subs.add(this.classService.list().subscribe(
      (data) => { this.classes = data; },
      (error) => {},
      () => {}
    ));

    this.subs.add(this.placeService.list().subscribe(
      (data) => { this.places = data; },
      (error) => {},
      () => {}
    ));

  }

  ngOnInit(): void {
    this.date.setValue(this.asset.aquisitionDate);
    this.currentState = this.asset.getState();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  updateState() {
    this.asset.setState(this.currentState);
    this.assetChanged.emit(this.asset);
  }

}
